<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/classes/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش کلاس</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="onlineClass.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="دوره" :items="courses" item-text="title" item-value="id"
                      color="black" v-model="onlineClass.course_id">
            </v-select>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="آموزشگاه" :items="schools" item-text="label" item-value="id"
                      color="black" v-model="onlineClass.school_id">
            </v-select>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="مربیان" :items="teachers" multiple item-text="name" item-value="id"
                      color="black" v-model="onlineClass.instructors">
            </v-select>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-autocomplete label="هنرجویان" :items="students" multiple item-text="name" item-value="id"
                            color="black" v-model="onlineClass.students">
            </v-autocomplete>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="روز"
                      :items="[{text:'شنبه',value:1},{text:'یکشنبه',value:2},{text:'دوشنبه',value:3},{text:'سه شنبه',value:4},{text:'چهارشنبه',value:5},{text:'پنجشنبه',value:6},{text:'جمعه',value:7}]"
                      item-text="text" item-value="value"
                      color="black" v-model="onlineClass.day">
            </v-select>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" type="number" v-model="onlineClass.hour" label="ساعت"
                          hint="بین ۰ تا ۲۳ وارد شود"></v-text-field>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" type="number" v-model="onlineClass.minute" label="دقیقه"
                          hint="بین ۰ تا ۶۰ وارد شود"></v-text-field>
          </v-col>

          <v-col cols="6" md="2" lg="2" sm="6">
            <v-text-field label="ظرفیت دوره" hint="عددی بین یک تا صد وارد شود"
                          color="black" v-model="onlineClass.capacity"></v-text-field>
          </v-col>

          <v-col cols="1" md="1" lg="1" sm="1">
            <v-checkbox
                label="موقت؟"
                v-model="onlineClass.is_temporary"
                color="black"
            >
            </v-checkbox>
          </v-col>

          <v-col cols="6" md="2" lg="2" sm="6">
            <vue-persian-datetime-picker color="black" v-model="onlineClass.start_date" custom-input="#start_date"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ شروع کلاس" v-model="onlineClass.start_date" id="start_date" color="black">
            </v-text-field>
          </v-col>

          <v-col cols="6" md="2" lg="2" sm="6">
            <vue-persian-datetime-picker color="black" v-model="onlineClass.pay_permission_date"
                                         custom-input="#pay_permission_date"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ اجازه پرداخت" v-model="onlineClass.pay_permission_date" id="pay_permission_date"
                          color="black">
            </v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field label="کاور"
                          @click="coverFileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="onlineClass.cover"></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="coverFileDialog" max-width="50vw">
      <drag-and-drop module="course" ref="image-uploader" @closeUploadFileDialog="coverFileDialog = false"
                     @changeFile="onlineClass.cover = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "OnlineClassEdit",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      coverFileDialog: false,
      schools: [],
      courses: [],
      teachers: [],
      students: [],
      onlineClass: {
        title: null,
        school_id: null,
        course_id: null,
        day: null,
        hour: null,
        minute: null,
        capacity: null,
        start_date: null,
        pay_permission_date: null,
        cover: null,
        instructors: [],
        students: [],
        is_temporary: false
      }
    }
  },
  mounted() {
    this.getClass()
    this.getSchools()
    this.getCourses()
    this.getTeachers()
    this.getStudents()
  },
  methods: {
    getClass() {
      window.axios.get('class/crud/get/' + this.$route.params.id).then((res) => {
        this.onlineClass = res.data.data
        this.onlineClass.start_date = res.data.data.start_date_fa
        this.onlineClass.pay_permission_date = res.data.data.pay_permission_date_fa
        if (this.onlineClass.instructors.length) {
          this.onlineClass.instructors.forEach((item, index) => {
            this.$set(this.onlineClass.instructors, index, item.id)
          })
        }
        if (this.onlineClass.students.length) {
          this.onlineClass.students.forEach((item, index) => {
            this.$set(this.onlineClass.students, index, item.id)
          })
        }
      })
    },
    update() {
      window.axios.post('class/crud/update/' + this.$route.params.id, this.onlineClass).then(() => {
        this.openSnackbar("کلاس مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getSchools() {
      window.axios.get('school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    },
    getCourses() {
      let url = '/course/crud/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.courses = res.data.data.data
      })
    },
    getTeachers() {
      let url = 'admin/instructor/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.teachers = res.data.data.data
      })
    },
    getStudents() {
      let url = 'admin/student/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.students = res.data.data.data
      })
    },
  }
}
</script>

<style scoped>

</style>